export const formatVkLink = (fromId) => (fromId ? `https://vk.com/${fromId < 0 ? 'club' : 'id'}${Math.abs(fromId)}` : '');
// API dates can be ISO/RFC strings or Unix timestamps in seconds/milliseconds.
export const parseDateValue = (value) => {
    if (value === null || value === undefined || typeof value === 'boolean') return null;
    if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : new Date(value.getTime());
    if (typeof value === 'string') {
        value = value.trim();
        if (!value) return null;
        if (/^[+-]?\d+(?:\.\d+)?$/.test(value)) value = Number(value);
    }
    if (typeof value !== 'string' && typeof value !== 'number') return null;
    if (typeof value === 'number') {
        if (!Number.isFinite(value)) return null;
        value = Math.abs(value) < 100000000000 ? value * 1000 : value;
    }
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
};

export const formatDate = (value, options) => {
    const date = parseDateValue(value);
    return date ? date.toLocaleString('ru-RU', options) : 'Нет даты';
};

export const truncateText = (text, limit = 10) => {
    if (!text) return 'Нет текста';
    const words = text.split(' ').filter((word) => word.length > 0);
    return words.length > limit ? words.slice(0, limit).join(' ') + '...' : text;
  };

